export const SET_PAGINATION_PER_PAGE = '@UI/DISK/PAGINATION/SET_PER_PAGE';
